/* ============================================================
   SYOCHI — interactions & content injection (vanilla)
   ============================================================ */
(function () {
  "use strict";

  /* ---------- NAV: solid on scroll ---------- */
  const nav = document.getElementById("nav");
  const heroEl = document.querySelector(".hero");
  function navState() {
    if (!heroEl) { nav.classList.add("is-solid"); return; }
    const typeHero = document.documentElement.getAttribute("data-hero") === "type";
    const threshold = heroEl.offsetHeight - 90;
    if (typeHero || window.scrollY > threshold) nav.classList.add("is-solid");
    else nav.classList.remove("is-solid");
  }
  window.addEventListener("scroll", navState, { passive: true });
  window.addEventListener("resize", navState);

  /* mobile menu drawer (built from nav links, shared across pages) */
  const menuBtn = document.querySelector(".nav__menu-btn");
  const linksEl = document.querySelector(".nav__links");
  if (menuBtn && linksEl) {
    const menu = document.createElement("div");
    menu.className = "mobile-menu";
    menu.innerHTML = linksEl.innerHTML;
    document.body.appendChild(menu);
    let open = false;
    const setOpen = (v) => {
      open = v;
      menu.classList.toggle("open", v);
      menuBtn.classList.toggle("open", v);
      document.body.classList.toggle("menu-open", v);
      if (v) nav.classList.add("is-solid");
      else navState();
    };
    menuBtn.addEventListener("click", () => setOpen(!open));
    menu.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => setOpen(false)));
    window.addEventListener("keydown", (e) => { if (e.key === "Escape" && open) setOpen(false); });
  }

  /* ---------- SMOOTH in-page anchors ---------- */
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener("click", (e) => {
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const t = document.querySelector(id);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
  });

  /* ---------- SCROLL REVEAL (scroll-driven, IO-independent) ---------- */
  function checkReveals() {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll(".reveal:not(.in)").forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) el.classList.add("in");
    });
  }
  function observeReveals() { checkReveals(); }
  window.addEventListener("scroll", checkReveals, { passive: true });
  window.addEventListener("resize", checkReveals);

  /* ---------- HERO PARALLAX ---------- */
  const heroMedia = document.querySelector(".hero__media");
  if (heroMedia) {
    window.addEventListener("scroll", () => {
      const y = window.scrollY;
      if (y < window.innerHeight) heroMedia.style.transform = `translateY(${y * 0.18}px) scale(1.05)`;
    }, { passive: true });
    heroMedia.style.transform = "scale(1.05)";
  }

  /* ---------- COUNT UP ---------- */
  function countUp(el) {
    const target = parseFloat(el.getAttribute("data-count"));
    const suffix = el.getAttribute("data-suffix") || "";
    const dur = 1400, start = performance.now();
    function tick(now) {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  const statEls = Array.from(document.querySelectorAll(".stat__num[data-count]"));
  function checkStats() {
    const vh = window.innerHeight;
    for (let i = statEls.length - 1; i >= 0; i--) {
      const el = statEls[i];
      const r = el.getBoundingClientRect();
      if (r.top < vh * 0.85 && r.bottom > 0) { countUp(el); statEls.splice(i, 1); }
    }
  }
  window.addEventListener("scroll", checkStats, { passive: true });

  /* ============================================================
     CONTENT DATA + RENDER
     ============================================================ */

  /* ---- Logo wall ---- */
  const partners = [
    { n: "Lumi Therapy", c: "United Kingdom", s: "84K customers", a: "EU recovery category leader" },
    { n: "Polar Recovery", c: "United States", s: "1,200 gyms", a: "Retail & commercial scale" },
    { n: "Hydragun", c: "Singapore", s: "120K units", a: "APAC bestseller" },
    { n: "Harvia", c: "Finland", s: "Since 1950", a: "Sauna heritage partner" },
    { n: "Icetubs", c: "Netherlands", s: "18 countries", a: "Premium ice baths" },
    { n: "TECKWAVE", c: "United Arab Emirates", s: "F1 paddock", a: "Elite sports partner" },
  ];
  const logoGrid = document.getElementById("logoGrid");
  if (logoGrid) logoGrid.innerHTML = partners.map((p) => `
    <div class="logo-cell">
      <span class="logo-cell__name">${p.n}</span>
      <div class="logo-cell__meta"><b>${p.c}</b> <span>${p.s} · ${p.a}</span></div>
    </div>`).join("");

  /* ---- Case studies ---- */
  const cases = [
    { num: "01", name: "Lumi Therapy", country: "United Kingdom",
      story: "From a single founder concept to the UK's leading recovery brand. We engineered Lumi's full plunge line, shell, chiller and finish, so they could focus entirely on building a category.",
      metrics: [["84K", "End customers"], ["11", "Markets"], ["4.9★", "Avg. rating"]],
      ph: "Lumi Therapy: finished cold plunge in studio setting" },
    { num: "02", name: "Hydragun", country: "Singapore",
      story: "A recovery-tech leader needed manufacturing that could match APAC demand without compromising on finish. We scaled production 4× across 18 months while holding a sub-1% defect rate.",
      metrics: [["120K", "Units shipped"], ["22", "Countries"], ["#1", "APAC recovery"]],
      ph: "Hydragun: ice bath product photography" },
    { num: "03", name: "Polar Recovery", country: "United States",
      story: "Commercial-grade plunges for 1,200+ gyms across North America. Engineered for 24/7 duty cycles, white-labelled end to end, delivered through our US logistics network.",
      metrics: [["1,200", "Gyms"], ["60K", "Units"], ["38%", "YoY growth"]],
      ph: "Polar Recovery: commercial gym installation" },
  ];
  const casesList = document.getElementById("casesList");
  if (casesList) casesList.innerHTML = cases.map((c) => `
    <article class="case reveal">
      <div class="case__media media">
        <span class="media__tag">${c.country}</span>
        <image-slot id="case-${c.num}" shape="rect" placeholder="${c.ph}"></image-slot>
      </div>
      <div class="case__body">
        <span class="case__num">${c.num}: Case Study</span>
        <h3 class="case__name h2">${c.name}</h3>
        <div class="case__country">${c.country}</div>
        <p class="case__story muted">${c.story}</p>
        <div class="case__metrics">
          ${c.metrics.map((m) => `<div class="case__metric"><div class="n">${m[0]}</div><div class="l">${m[1]}</div></div>`).join("")}
        </div>
        <a href="#" class="case__link link">Read the partnership <span class="arrow">→</span></a>
      </div>
    </article>`).join("");

  /* ---- World map ---- */
  const mapwrap = document.getElementById("mapwrap");
  if (mapwrap) {
    const W = 1000, H = 460, step = 15, r = 1.7;
    // rough continental ellipses [cx,cy,rx,ry]
    const land = [
      [205, 150, 115, 88], [300, 330, 52, 95], [510, 128, 58, 52],
      [545, 275, 78, 102], [710, 150, 155, 95], [835, 350, 60, 42], [560, 120, 40, 38],
    ];
    function inLand(x, y) {
      return land.some(([cx, cy, rx, ry]) => ((x - cx) ** 2) / (rx * rx) + ((y - cy) ** 2) / (ry * ry) <= 1);
    }
    let dots = "";
    for (let y = 20; y < H; y += step) {
      for (let x = 20; x < W; x += step) {
        if (inLand(x, y)) dots += `<circle class="dot" cx="${x}" cy="${y}" r="${r}"></circle>`;
      }
    }
    const pins = [
      { x: 205, y: 168, n: "United States", s: "Logistics hub · 24/7" },
      { x: 498, y: 120, n: "United Kingdom", s: "Lumi Therapy" },
      { x: 540, y: 100, n: "Finland", s: "Harvia" },
      { x: 510, y: 132, n: "Netherlands", s: "Icetubs" },
      { x: 600, y: 215, n: "United Arab Emirates", s: "TECKWAVE · F1" },
      { x: 748, y: 250, n: "Singapore", s: "Hydragun · APAC" },
      { x: 838, y: 350, n: "Australia", s: "Distribution" },
    ];
    const pinSvg = pins.map((p, i) => `
      <g class="pin" data-i="${i}">
        <circle class="ring" cx="${p.x}" cy="${p.y}" r="5"></circle>
        <circle class="core" cx="${p.x}" cy="${p.y}" r="4.2"></circle>
      </g>`).join("");
    mapwrap.innerHTML = `
      <svg class="worldmap" viewBox="0 0 ${W} ${H}" role="img" aria-label="World map of partner locations">
        ${dots}${pinSvg}
      </svg>
      ${pins.map((p, i) => `<div class="pin-label" data-i="${i}" style="left:${(p.x / W) * 100}%;top:${(p.y / H) * 100}%"><b>${p.n}</b><span>${p.s}</span></div>`).join("")}`;
    mapwrap.querySelectorAll(".pin").forEach((g) => {
      const i = g.getAttribute("data-i");
      const label = mapwrap.querySelector(`.pin-label[data-i="${i}"]`);
      g.addEventListener("mouseenter", () => { label.style.opacity = 1; });
      g.addEventListener("mouseleave", () => { label.style.opacity = 0; });
    });
  }

  /* ---- Capabilities ---- */
  const caps = [
    { t: "OEM Manufacturing", p: "Design-to-spec production with your branding, from prototype to mass output.",
      svg: '<path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/>' },
    { t: "Commercial Chillers", p: "High-duty cooling systems engineered for continuous commercial cycles.",
      svg: '<path d="M12 2v20M4 7l16 10M20 7L4 17"/><path d="M12 6l3-3M12 6L9 3M12 18l3 3M12 18l-3 3"/>' },
    { t: "Global Logistics", p: "Freight, customs and last-mile delivery managed across 7+ countries.",
      svg: '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18"/>' },
    { t: "North America Support", p: "Dedicated 24/7 service, warranty and parts network across the region.",
      svg: '<path d="M4 12a8 8 0 0 1 16 0v5a3 3 0 0 1-3 3h-1v-7h4M4 12v5a3 3 0 0 0 3 3h1v-7H4"/>' },
  ];
  const capsGrid = document.getElementById("capsGrid");
  if (capsGrid) capsGrid.innerHTML = caps.map((c) => `
    <div class="cap"><svg viewBox="0 0 24 24">${c.svg}</svg><h3 class="h3">${c.t}</h3><p>${c.p}</p></div>`).join("");

  /* ---- Product grid ---- */
  const prods = [
    { t: "Ice Baths", p: "Single & dual-temp", ph: "Ice bath on white" },
    { t: "Chillers", p: "Commercial cooling", ph: "Chiller unit on white" },
    { t: "Saunas", p: "Infrared & traditional", ph: "Sauna cabin on white" },
    { t: "Accessories", p: "Covers, steps, filtration", ph: "Accessories flat-lay" },
  ];
  const prodGrid = document.getElementById("prodGrid");
  if (prodGrid) prodGrid.innerHTML = prods.map((p, i) => `
    <a class="prod-card" href="Products.html">
      <div class="frame"><image-slot id="prod-${i}" shape="rect" placeholder="${p.ph}"></image-slot></div>
      <h4>${p.t}</h4><p>${p.p}</p>
    </a>`).join("");

  /* ---- OEM timeline ---- */
  const steps = [
    { t: "Discovery", p: "We map your brand, market and volume targets.", svg: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/>' },
    { t: "Customization", p: "Shell, finish, dimensions and features to spec.", svg: '<path d="M4 20l5-5M14 6l4 4M13 7l3-3 4 4-3 3zM4 20v-4h4"/>' },
    { t: "Engineering", p: "Chillers, electronics and durability validated.", svg: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>' },
    { t: "Production", p: "Scaled manufacturing with strict QC.", svg: '<path d="M3 21V9l6 4V9l6 4V9l6 4v8z"/>' },
    { t: "Branding", p: "Your logo, packaging and finish applied.", svg: '<path d="M4 7h16M4 12h10M4 17h7"/><circle cx="18" cy="15" r="3"/>' },
    { t: "Global Delivery", p: "Freight and last-mile to your market.", svg: '<path d="M2 7h11v8H2zM13 10h5l3 3v2h-8z"/><circle cx="6" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/>' },
  ];
  const timeline = document.getElementById("timeline");
  if (timeline) timeline.innerHTML = steps.map((s, i) => `
    <div class="step"><div class="step__n">0${i + 1}</div><svg viewBox="0 0 24 24">${s.svg}</svg><h4>${s.t}</h4><p>${s.p}</p></div>`).join("");

  /* ---- Form validation ---- */
  const form = document.getElementById("inquiryForm");
  if (form) {
    const setInvalid = (field, bad) => field.classList.toggle("invalid", bad);
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      let ok = true;
      const company = form.company, name = form.name, email = form.email, market = form.market;
      [["company", company], ["name", name], ["market", market]].forEach(([k, el]) => {
        const bad = !el.value.trim(); setInvalid(el.closest(".field"), bad); if (bad) ok = false;
      });
      const emailBad = !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim());
      setInvalid(email.closest(".field"), emailBad); if (emailBad) ok = false;
      if (ok) {
        form.style.display = "none";
        document.getElementById("formSuccess").classList.add("show");
      }
    });
    form.querySelectorAll("input, select").forEach((el) => {
      el.addEventListener("input", () => el.closest(".field").classList.remove("invalid"));
    });
  }

  /* init */
  observeReveals();
  checkStats();
  navState();
  // settle passes for late layout/fonts
  requestAnimationFrame(() => { checkReveals(); checkStats(); });
  window.addEventListener("load", () => { checkReveals(); checkStats(); });
  window.__syochiObserveReveals = observeReveals; // re-run after tweak re-renders
})();
